import React, { useState } from 'react';
import axios from 'axios';

const ContactForm = () => {
  const [form, setForm] = useState({ nom: '', email: '', telephone: '', message: '' });
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, form);
      setStatus('success');
      setForm({ nom: '', email: '', telephone: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
      <h3 className="text-xl font-bold text-white mb-4">📬 Nous contacter</h3>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input required placeholder="Votre nom" value={form.nom}
          onChange={e => setForm({...form, nom: e.target.value})}
          className="w-full bg-white/10 text-white placeholder-white/50 rounded-lg p-3 border border-white/20" />
        <input required type="email" placeholder="Votre email" value={form.email}
          onChange={e => setForm({...form, email: e.target.value})}
          className="w-full bg-white/10 text-white placeholder-white/50 rounded-lg p-3 border border-white/20" />
        <input placeholder="Téléphone (optionnel)" value={form.telephone}
          onChange={e => setForm({...form, telephone: e.target.value})}
          className="w-full bg-white/10 text-white placeholder-white/50 rounded-lg p-3 border border-white/20" />
        <textarea required placeholder="Votre message" value={form.message}
          onChange={e => setForm({...form, message: e.target.value})}
          rows={4}
          className="w-full bg-white/10 text-white placeholder-white/50 rounded-lg p-3 border border-white/20" />
        <button type="submit"
          className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-lg transition-all">
          Envoyer 📤
        </button>
        {status === 'success' && <p className="text-green-400 text-center">✅ Message envoyé !</p>}
        {status === 'error' && <p className="text-red-400 text-center">❌ Erreur, réessayez.</p>}
      </form>
    </div>
  );
};

export default ContactForm;
